import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../views/Store.vue'
import Record from '../views/Record.vue'
import GiftCredits from '../views/GiftCredits.vue'
import Faq from '../views/Faq.vue'
import User from '../views/User.vue'
import UserIndex from '../views/user/Index.vue'
import ChangePwd from '../views/user/ChangePwd.vue'
import CheckEmail from '../views/user/CheckEmail.vue'
import BindEmail from '../views/user/BindEmail.vue'
import BindSuccess from '../views/user/BindSuccess.vue'
import Consume from '../views/user/Consume.vue'
import FaqIndex from '../views/faq/Index.vue'
import SearchResult from '../views/faq/SearchResult.vue'
import Content from '../views/faq/Content.vue'
import Submit from '../views/faq/Submit.vue'
import History from '../views/faq/History.vue'
import Chat from '../views/faq/Chat.vue'
import RecordIndex from '../views/record/Index.vue'
import RecordContent from '../views/record/Content.vue'
import NtRecord from '../views/user/NtRecord.vue'
import PointBuy from '../views/user/PointBuy.vue'
import PointCost from '../views/user/PointCost.vue'
import BindUid from '../views/user/BindUid.vue'
import UpdateUid from '../views/user/UpdateUid.vue'
import GameRegulations from '../views/user/GameRegulations.vue'
import Exchange from '../views/user/Exchange.vue'
import EmailSubmit from '../views/faq/EmailSubmit.vue'
import Report from '../views/faq/Report.vue'
import Inherit from '../views/user/Inherit.vue'
import InheritComp from '../views/user/InheritComp.vue'

Vue.use(VueRouter)
const routes = [{
        path: '/',
        redirect: '/user'
    },
    {
        path: '/store',
        name: 'store',
        component: Store
    },
    {
        path: '/record',
        name: 'integral',
        component: Record,
        redirect: '/record/index',
        children: [{
            path: 'index',
            name: '积分首页',
            component: RecordIndex
        }, {
            path: 'content',
            name: '积分内容页',
            component: RecordContent
        }]
    },
    {
        path: '/giftcredits',
        name: '礼包',
        component: GiftCredits
    },
    {
        path: '/faq',
        name: 'customerService',
        component: Faq,
        redirect: '/faq/index',
        children: [{
            path: 'index',
            name: '客服首页',
            component: FaqIndex
        }, {
            path: 'searchResult',
            name: '搜索结果',
            component: SearchResult
        }, {
            path: 'report',
            name: '举报用户',
            component: Report
        }, {
            path: 'content',
            name: '客服内容页',
            component: Content
        }, {
            path: 'submit',
            name: '提交内容页',
            component: Submit
        }, {
            path: 'history',
            name: '历史会话',
            component: History
        }, {
            path: 'chat',
            name: '对话框',
            component: Chat
        }, {
            path: 'emailSubmit',
            name: '邮件',
            component: EmailSubmit
        }]
    },
    {
        path: '/user',
        name: 'accountID',
        component: User,
        redirect: '/user/index',
        children: [{
            path: 'index',
            name: '账号首页',
            component: UserIndex
        }, {
            path: 'changePwd',
            name: '修改密码',
            component: ChangePwd
        }, {
            path: 'inherit',
            name: '引继码生成',
            component: Inherit
        }, {
            path: 'inheritComp',
            name: '引继码生成完成',
            component: InheritComp
        }, {
            path: 'updateUid',
            name: '升级账号',
            component: UpdateUid
        }, {
            path: 'bindUid',
            name: '绑定账号',
            component: BindUid
        }, {
            path: 'bindEmail',
            name: '绑定邮箱',
            component: BindEmail
        }, {
            path: 'bindSuccess',
            name: '邮箱绑定成功',
            component: BindSuccess
        }, {
            path: 'checkEmail',
            name: '查看邮箱',
            component: CheckEmail
        }, {
            path: 'consume',
            name: '消费记录',
            component: Consume
        }, {
            path: 'ntRecord',
            name: 'NT充值记录',
            component: NtRecord
        }, {
            path: 'pointBuy',
            name: '积分购买',
            component: PointBuy
        }, {
            path: 'pointCost',
            name: '积分消耗',
            component: PointCost
        }, {
            path: 'exchange',
            name: '积分消耗',
            component: Exchange
        }, {
            path: 'gameRegulations',
            name: '游戏规范',
            component: GameRegulations
        }]
    }
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router